import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useCreateCandidate() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (candidate) => {
      return axios.post(`/candidate`, candidate);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["candidates"] });
    },
  });
}
